module.exports = __webpack_public_path__ + "h5/img/card_pic.6c450a87.png";